import { assertValidVersion } from "@tsparticles/engine";
import { RotateUpdater } from "./RotateUpdater.js";
export async function loadRotateUpdater(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addParticleUpdater("rotate", container => {
        return Promise.resolve(new RotateUpdater(container));
    }, refresh);
}
